import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PERSON_INN_LENGTH } from '../../constants/requisitesLength';
import { checkExactLength, checkInnFormat, checkMatch, checkNotEmpty } from '../../helpers/validators';
import { MatchLink } from '../MatchLink';
export const validateEmployeeINN = ({ value, required }) => {
    if (required) {
        return (checkNotEmpty({ value }) ||
            checkExactLength({
                value,
                type: 'lostfocus',
                length: PERSON_INN_LENGTH,
            }) ||
            checkInnFormat({ value, type: 'lostfocus' }));
    }
    if (!value) {
        return null;
    }
    return (checkExactLength({
        value,
        type: 'lostfocus',
        length: PERSON_INN_LENGTH,
    }) || checkInnFormat({ value, type: 'lostfocus' }));
};
export const checkMatchInn = ({ value, matchValue, matchEmployeeLink, level, }) => {
    const message = (_jsxs(_Fragment, { children: ["\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A \u0441 \u0442\u0430\u043A\u0438\u043C \u0418\u041D\u041D \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442", matchEmployeeLink && '. ', matchEmployeeLink && _jsx(MatchLink, { matchEmployeeLink: matchEmployeeLink })] }));
    return checkMatch({ value, matchValue, matchFields: ['inn'], message, level });
};
